const e = {
  name: "Hungary",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M8,7c0-1.9,1.3-3.4,3-3.9V0h2v3.1c1.7,0.4,3,2,3,3.9v0.8l2-4l4,8V24H2V11.9l4-8.1l2,4V7z M16.1,12h3.8L18,8.2
			L16.1,12z M20,14h-4v8h4V14z M14,12V7c0-1.1-0.9-2-2-2s-2,0.9-2,2v5H14z M8,14H4v8h4V14z M7.9,12L6,8.3L4.2,12H7.9z M14,14h-4v8h4
			V14z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Hungary
};
